// Celigo's official mark is a monogram (squircle + "C"); they publish no SVG, so
// this recreates it. Rendered as a light tile for contrast on the dark UI.
export function CeligoIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="23" height="23" rx="6" fill="#F2F2F2" />
      <path
        d="M16.5 9.25a5 5 0 1 0 0 5.5"
        stroke="#0A0A0A"
        strokeWidth="2.7"
        strokeLinecap="butt"
        fill="none"
      />
    </svg>
  );
}
